<template>
  <div>

    <v-sheet class="ma-8 mt-2 pa-4 rounded-lg" v-if="!issueCompleted">
      <v-card-text>

        <FormulateForm #default="{ isLoading }" @submit="submitForm">
          <FormulateInput
              label="Waar heeft u een probleem mee?"
              type="radio"
              validation="required"
              :options="{
                'registration': 'Formulier invullen',
                'form': 'Formulier beheren',
                'user': 'Gebruikers beheren',
                'other': 'Overige',
              }"
              v-model="issueType"
              class="mb-0"
          />
          <FormulateInput
              type="textarea"
              label="Beschrijf uw probleem"
              name="issue_description"
              placeholder="Bijvoorbeeld: Welke stappen heeft u ondernomen? Wat verwachtte u dat er zou gebeuren? Wat gebeurde er in plaats daarvan?"
              :help="issueDescription.length < 20 ? `Schrijf nog minimaal ${20 - issueDescription.length} karakters.` : ''"
              v-model="issueDescription"
              rows="7"
              validation="required|min:20,length"
          />
          <FormulateInput
              input-class="v-btn v-size--default primary"
              type="submit"
              name="submit"
              :disabled="isLoading"
              :label="isLoading ? 'Laden...' : 'Verstuur ticket'"
          />
        </FormulateForm>
      </v-card-text>
    </v-sheet>

    <v-sheet class="ma-8 mt-2 pa-4 rounded-lg" v-if="issueCompleted">
      <v-card-text>
        <v-alert color="secondary" dense text>
          <strong>Uw support ticket is succesvol ingediend.</strong>
        </v-alert>
        <p>Uw ticket nummer is <strong>{{ issueId }}</strong></p>
      </v-card-text>
    </v-sheet>

  </div>
</template>

<script>
import axios from "axios";
import Vue from "vue";

export default {
  data: () => ({
    issueId: null,
    issueType: null,
    issueDescription: '',
    issueCompleted: false,
    rollbarUuid: null,
  }),
  created() {
    this.generateIssueId();
  },
  async mounted() {
    // Trigger a Rollbar info event to log that the help ticket page was opened
    let occurrence = await Vue.prototype.$rollbar.critical('Help ticket page opened', {
      issue_id: this.issueId,
    });
    // Store the Rollbar UUID for reference
    this.rollbarUuid = occurrence.uuid;
  },
  methods: {
    generateIssueId() {
      const timestamp = Date.now().toString(36)
      const randomString = Math.random().toString(36).substring(2, 4);
      this.issueId = `${timestamp}${randomString}`.toUpperCase().replace(/[0O]/g, 'Z');
    },
    // Send the form to the API endpoint
    async submitForm() {
        try {
          const response = await axios.post(`api/help/ticket`, {
            issue_id: this.issueId,
            issue_type: this.issueType,
            issue_description: this.issueDescription,
            client_name: this.$store.getters.CurrentClientName,
            rollbar_uuid: this.rollbarUuid,
          });

          if (response && response.status === 200) {
            this.issueCompleted = true;
            return;
          }

        } catch (error) {
          console.error(error);
          this.$toast.error('Er is een fout opgetreden bij het indienen van uw ticket. Probeer het opnieuw.');
          return;
        }

        this.$toast.error('Er is een fout opgetreden bij het indienen van uw ticket. Probeer het opnieuw.');
    }
  }
}
</script>

<style scoped>

</style>